import { ExclamationTriangleIcon } from '@heroicons/react/20/solid'

const NetworkErrorAlert = () => {
  return (
    <div className="fixed right-5 top-16 rounded-md bg-red-200 border border-red-500 p-4 z-50 w-fit mx-auto">
      <div className="flex">
        <div className="flex-shrink-0">
          <ExclamationTriangleIcon aria-hidden="true" className="h-5 w-5 text-red-500" />
        </div>
        <div className="ml-3">
          <p className="text-sm font-medium text-label-normal">
            Network error: We are currently unable to process your request. <br /> Please refresh
            this page and try again.{' '}
          </p>
        </div>
      </div>
    </div>
  )
}

export default NetworkErrorAlert
